export interface FormField {
    type: string;
    options: FormFieldOptions;
}

export interface FormFieldOptions {
    path: string;
    label?: FormFieldLabel;
    class?: string;
    placeholder?: string;
    // textarea
    rows?: number;
    // Dropdown
    dropdown?: FormFieldDropdown;
	multi?: boolean;
    // Switchers
    switchers?: FormFieldSwitchers;
    // Image
    image?: FormFieldImage;
    //
    resource?: FormFieldResource;
}

export interface FormFieldLabel {
    class?: string;
    text: string;
}

export interface FormFieldDropdown {
    text: string;
    default?: any;
    options: FormFieldDropdownOption[];
	optionsValueField?: string;
	optionsLabelField?: string;
}

export interface FormFieldDropdownOption {
    [otherAttr: string]: any;
	id: number | string;
    name: string;
}

export interface FormFieldSwitchers {
    trueValue?: any;
    trueCaption?: string;
    falseValue?: any;
    falseCaption?: string;
}

export interface FormFieldImage {
    src: string; // base64 || url;
    class?: string;
    selectPhotoButton?: FormFieldImageSelectPhoto;
}

export interface FormFieldImageSelectPhoto {
    text: string;
    class: string;
}

export interface FormFieldResource {
  src: string; // url;
  isVideo: boolean;
}

export const MAX_FILE_SIZE_VIDEO = 94371840;
export const MAX_FILE_SIZE_IMAGE = 2097152;
export const BYTES_LONG = 1048576;
